<template>
  <!-- pc端 -->
  <div class="banner">
    <swiper :options="swiperOption"  ref="mySwiper" class="swiper-wrapper">
      <!-- 第一张 -->
      <!-- <swiper-slide>
        <div class="banner-first-content">
          <div class="banner-title">即安文旅</div>
          <ul class="banner-ul">
            <li class="banner-li">致力于构建综合性文旅新生态</li>
          </ul>
          <img class="banner-first-img" src="https://jianwenlv-prod.oss-cn-hangzhou.aliyuncs.com/static/1733207701285.png" alt="">
        </div>
      </swiper-slide> -->
      <!-- 第二张 -->
      <swiper-slide>
        <!-- <img v-if="$language == 'en'" class="banner-img" src="https://ptc-testing.com/static/upload/2024/07/16/202407161238.png" alt=""> -->
        <img v-if="$language == 'en'" class="banner-img" src="https://hzlxjzx.oss-cn-hangzhou.aliyuncs.com/backgroundManagement/static/1747058315533/WechatIMG10296.jpg" alt="">
      
        <img v-else  class="banner-img" src="https://hzlxjzx.oss-cn-hangzhou.aliyuncs.com/backgroundManagement/static/1747058315533/WechatIMG10296.jpg" alt="">
      </swiper-slide>
      <!-- 第三张 -->
      <!-- <swiper-slide>
        <img class="banner-img"  src="https://hzlxjzx.oss-cn-hangzhou.aliyuncs.com/backgroundManagement/static/1747037098415/02.jpg'" alt="">
      </swiper-slide> -->
      <!-- 第四张 -->
      <!-- <swiper-slide>
        <img class="banner-img"  src="https://jianwenlv-prod.oss-cn-hangzhou.aliyuncs.com/static/1733209582094.png" alt="">
      </swiper-slide> -->
      <div style="bottom: 80px" class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"></div>
      <!-- <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div> -->
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: 'BannerComponent',
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
  },
  components: {swiper, swiperSlide},
  data () {
    return {
      swiperOption: {
        loop: false, // 循环模式选项
        autoplay: true,
        speed: 1500,
        effect : 'fade',
        // navigation: {
        //   nextEl: ".swiper-button-next",
        //   prevEl: ".swiper-button-prev",
        // },
        pagination: {
          el: '.swiper-pagination',
          bulletElement: 'div',
          clickable :true,
        }
      },
      imgUrls: [
        'https://hzlxjzx.oss-cn-hangzhou.aliyuncs.com/backgroundManagement/static/1747037073040/01.jpg',
        'https://hzlxjzx.oss-cn-hangzhou.aliyuncs.com/backgroundManagement/static/1747037098415/02.jpg',
      ],
      windowWidth: 0,
  
    }
  },
  watch:{ 
    windowWidth (val) {
      const _this = this
      _this.windowWidth = val
    }
  },
  mounted () {
    // 获取当前屏幕宽度
    let _this = this
    _this.windowWidth = document.documentElement.clientWidth

  }
}
</script>
<style scoped>
div{
  box-sizing: border-box;
}
.banner{
  width: 100%;
  height: 600px;
  margin-top: 80px;
}
.banner-img{
  width: 100%;
}
.banner-first-content{
  width: 100%;
  height: 100%;
  background: linear-gradient(111deg, #ACCBEE 0%, #E7F0FD 100%);
  background-size: cover;
  padding: 200px 180px;
  position: relative;
}
.banner-second-info{
  width: 1018px;
  height: 597px;
}
.banner-title{
  font-size: 80px;
  font-weight: 700;
  color: #282828;
  text-align: left;
  margin-bottom: 30px;
  padding-top: 100px;
}
.banner-ul{
  width: 1018px;
  height: 288px;
  font-size: 36px;
  font-weight: 400;
  color: #282828;
}
.banner-li{
  line-height: 96px;
  text-align: left;
}

.swiper-wrapper{
  position: relative;
}
.swiper-pagination{
  position: fixed;
  bottom: 0;
  left: 50%;
}
.banner-first-img{
  width: 573px;
  height: 573px;
  position: absolute;
  top: 200px;
  right: 200px;
  transition: all 1s;
  animation: imgJump 1s ease-in-out infinite alternate;
}
/* 动画 */
@keyframes imgJump {
  from { top: 200px; }
  to { top: 240px }
}
</style>
<style>
.swiper-pagination-bullet{
  width: 15px;
  height: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/newHomeComponents/bannerComponent.vue